/**
 * Computes the default name for a new buddy group: "Buddy Group N" where N
 * is one greater than the largest matching index in `existingNames`. Names
 * the user renamed (anything not matching `Buddy Group <number>`) are
 * ignored, and gaps from deleted groups are not reused — keeps the counter
 * monotonic and predictable for the user.
 */
export function getDefaultBuddyGroupName(existingNames: readonly (string | null | undefined)[] = []): string {
  const pattern = /^Buddy Group (\d+)$/;
  let max = 0;
  for (const name of existingNames) {
    if (typeof name !== 'string') continue;
    const match = pattern.exec(name.trim());
    if (!match) continue;
    const n = parseInt(match[1], 10);
    if (Number.isFinite(n) && n > max) max = n;
  }
  return `Buddy Group ${max + 1}`;
}
